import Swiper from 'swiper';
import 'swiper/css';


const constraints = {
  price: {
    testFn(value) {
      return value.trim() === "" || Number.isInteger(parseInt(value));
    },
    message: "Veuillez entrer un prix valide",
  },
  compare: {
    testFn(value, otherValue) {
      const numValue = parseInt(value);
      const numOtherValue = parseInt(otherValue);

      const isBothValuesEmpty = value.trim() === "" && otherValue.trim() === "";

      const isEitherValueValid =
        (Number.isInteger(numValue) && otherValue.trim() === "") ||
        (Number.isInteger(numOtherValue) && value.trim() === "");

      const isValueGreatherThanOrEqual =
        Number.isInteger(numValue) &&
        Number.isInteger(numOtherValue) &&
        numValue >= numOtherValue;

      return (
        isBothValuesEmpty || isEitherValueValid || isValueGreatherThanOrEqual
      );
    },
    message: "Cette valeur ne peut pas être inférieure au champ précédent",
  },
};

const applyValidation = (validatableElement, testFn, errorMessageSelector) => {
  const isInputValid = testFn(validatableElement.value);

  if (!isInputValid) {
    validatableElement.setCustomValidity(constraints.price.message);
    const errorMessageWrapper = document.querySelector(errorMessageSelector);

    if (errorMessageWrapper) {
      errorMessageWrapper.textContent = constraints.price.message;
    }
  }

  return isInputValid;
};

// Add the behavior each time htmx reloads, only on document load is
// unsufficient
document.body.addEventListener("htmx:load", () => {
  document.querySelectorAll("[data-validation-container]").forEach((el) => {
    const priceValidation = el.querySelectorAll("[data-validation-price]");
    const compareValidation = el.querySelectorAll("[data-validation-compare]");
    const validationTrigger = el.querySelector("[data-validation-trigger]");

    const validateInputs = () => {
      let allValidationPasses = true;

      priceValidation.forEach((inputField) => {
        allValidationPasses =
          allValidationPasses &&
          applyValidation(
            inputField,
            constraints.price.testFn,
            `[data-validation-message-for="#${inputField.id}"]`,
          );
      });

      compareValidation.forEach((inputField) => {
        allValidationPasses =
          allValidationPasses &&
          applyValidation(
            inputField,
            (value) => {
              const compareField = el.querySelector(
                inputField.dataset.validationCompare,
              );
              return constraints.compare.testFn(value, compareField.value);
            },
            `[data-validation-message-for="#${inputField.id}"]`,
          );
      });

      if (allValidationPasses) {
        const validationSuccessfulEvent = new Event("validation-successful");
        validationTrigger.dispatchEvent(validationSuccessfulEvent);
      }
    };

    validationTrigger.addEventListener("click", () => validateInputs());
  });

  document.querySelectorAll("[data-message-container]").forEach((el) => {
    const closeButtonElements = el.querySelectorAll("[data-message-close]");

    const handleClose = (item) => {
      const messageItem = item.closest("[data-message-item]");
      messageItem.classList.add("hidden");
      messageItem.closest("[data-message-container]").remove();
    };

    closeButtonElements.forEach((item) =>
      item.addEventListener("click", () => handleClose(item)),
    );
  });

  document.querySelectorAll("[data-clear-select]").forEach((el) => {
    const handleClick = () => {
      const selectElement = document.querySelector(el.dataset.clearSelect);
      if (selectElement) {
        selectElement.value = "";
        selectElement.dispatchEvent(new Event("input"));
        selectElement.dispatchEvent(new Event("change"));
      }
    };
    el.addEventListener("click", () => handleClick());
  });
});



document.body.addEventListener("htmx:load", () => {

  var swiper = new Swiper(".thumbnail_swiper", {
    spaceBetween: 10,
    direction: "horizontal",
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        direction: "vertical"
      },
    },


  });
  var swiper2 = new Swiper(".main_swiper", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
});

